<nav class="briciole" aria-label="Percorso">
  <ol class="briciole__elenco">
    <li class="briciole__voce">
      <a class="briciole__link" href="/">
        <mat-icon class="briciole__casa" aria-hidden="true">home</mat-icon>
        <span class="briciole__solo-larghi">Dashboard</span>
      </a>
    </li>

    @for (breadcrumb of breadcrumbs$(); track breadcrumb; let last = $last) {
      @if (!breadcrumb.eHome) {
        <li class="briciole__voce" [attr.aria-current]="last ? 'page' : null">
          <mat-icon class="briciole__separatore" aria-hidden="true">chevron_right</mat-icon>
          @if (last) {
            <span class="briciole__attuale">{{ breadcrumb.label | translate }}</span>
          } @else {
            <button type="button" class="briciole__link" (click)="redirectTo(breadcrumb.url)">
              {{ breadcrumb.label | translate }}
            </button>
          }
        </li>
      }
    }
  </ol>
</nav>
